import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepicker, MatDatepickerModule } from "@angular/material/datepicker";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { DatePipe } from "@angular/common";
import { TalentProfileApiService } from "../../../talent-profile/talent-profile-api.service";
import { TranslateModule } from '@ngx-translate/core';
import { UtilService } from '../../service/util.service';

@Component({
    selector: 'app-date-picker',
    imports: [
        MatButtonModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        FormsModule,
        TranslateModule
    ],
    templateUrl: './date-picker.component.html',
    styleUrl: './date-picker.component.scss'
})
export class DatePickerComponent implements OnInit {
  @Input() personId: number;
  @Input() selectedDate: Date;
  @Output() selectedDateChange = new EventEmitter<Date>();
  formattedDate: string;
  localeId: number;

  constructor(
    private datePipe: DatePipe,
    private utilService: UtilService,
    private profileService: TalentProfileApiService) {}


  ngOnInit(): void {
    this.profileService.getLocaleId(this.personId).subscribe(localeId => {
      this.localeId = localeId;
      this.formattedDate = this.datePipe.transform(this.selectedDate, this.utilService.getDateFormat(this.localeId));
    });
  }

  onDateChange(picker: MatDatepicker<Date>) {
    this.formattedDate = this.datePipe.transform(this.selectedDate, this.utilService.getDateFormat(this.localeId));
    this.selectedDateChange.emit(this.selectedDate);
  }

}
